import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Route } from 'react-router-dom';

import './section.css';
import { urlJoin } from '../../utils/url-utils';
import { uploadFile } from './section.actions';
import CardList from './components/card-list';
import MiniCardList from './components/minicard-list';
import ItemList from './components/item-list';
import EmptyList from './components/empty-list';
import routes from '../../utils/routes';

const SectionOrCards = props => {
    const { match, cards = [], links, isActivity, history } = props;
    let card = {};
    if (cards.length > 0) {
        // eslint-disable-next-line
        card = cards.find(card => card.id == match.params.id);
        if (!card) {
            history.push(routes.HOME);
            card = {};
        }
    }
    const currentLinks = links.concat({ title: card.title, url: match.url });
    const allProps = {
        ...props,
        card,
        links: currentLinks,
        name: cards.indexOf(card),
        updateNestedItem,
    };
    if (card.cards && card.cards.length > 0) {
        return (
            <React.Fragment>
                {match.isExact && <CardList {...allProps}/>}
                <RecursiveContents {...allProps} parent={card}/>
            </React.Fragment>);
    } else if (card.minicards && card.minicards.length > 0) {
        return (
            <React.Fragment>
                {match.isExact && <MiniCardList {...allProps}/>}
                <RecursiveContents {...allProps} parent={card}/>
            </React.Fragment>);
    } else if (isActivity) {
        // ToDo: remove this hack once activities have an id
        card.items.forEach((item) => {
            item.items
                .forEach((subItem) => subItem.id = subItem.id || item.title);
        });
        return <ItemList {...allProps}/>;
    } else if (card.items && card.items.length > 0) {
        return <ItemList {...allProps}/>;
    } else {
        return <EmptyList {...allProps}/>;
    }

    function updateNestedItem(key, value) {
        const cards = [...props.cards];
        value !== undefined ? cards[key] = value : cards.splice(key, 1);
        props.updateNestedItem(props.name, cards);
    }
};

const Class = (props) => {
    const { match, links, parent: card, name } = props;

    const allProps = {
        ...props,
        card,
        links,
        name,
    };
    return (
        <React.Fragment>
            {match.isExact && <CardList {...allProps}/>}
            <RecursiveContents {...allProps} parent={card}/>
        </React.Fragment>
    );
};

const RecursiveContents = ({ match, parent, links, name, updateNestedItem, ...rest }) => {
    return <Route
        path={urlJoin(match.url, ':id')}
        render={props => <SectionOrCards
            {...rest} {...props} isActivity={!!parent.minicards}
            cards={parent.cards || parent.minicards} links={links}
            name={parent.cards ? 'cards' : 'minicards'}
            updateNestedItem={(key, value) => updateNestedItem(name, { ...parent, [key]: value })}
        />}
    />;
};

const mapStateToProps = ({ trainers, centers, courses }, { match, classes, idProp, links = [], history }) => {
    let parent = {};
    if (classes && classes.length > 0) {
        // eslint-disable-next-line
        parent = classes.find(c => c[idProp] == match.params.id);
        if (!parent) {
            history.push(routes.HOME);
            parent = {};
        }
    }
    
    parent.cards = parent.cards || [];
    const currentCourses = courses.data.find(e=>e.courseId === parent.courseId);
    return {
        parent,
        name: parent[idProp],
        links: links.concat({ title: currentCourses ? `${currentCourses.courseName}${parent.className ? ` / ${parent.className }`: ''}` : parent.className || ((currentCourses && currentCourses.courseName) || ''), url: match.url }),
        trainers: trainers.data,
        centers: centers,
    };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({ uploadFile }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Class);


// WEBPACK FOOTER //
// ./src/components/section/section.js